export const MY_ACCOUNT_ROUTE = 'konto';
